<template lang="pug">
  .container-restricao
      div(
          v-if='restricoes.length > 0',
          :class='restricoes[index].inibido ? "camada-inibida" : ""',
          v-for='(restricao, index) in listaRestricoes'
      )
          slot(name='botaoInibir', :restricao='restricoes[index]')
          .card-restricao
              .container-restricao-acoes(
                  v-if='existeDadosGeoEspaciais(restricoes[index])'
              )
                  div
                    BaseButton(
                          size='small',
                          icon='mdi mdi-crosshairs-gps',
                          @click='aplicarZoomRestricao(index)'
                      )
              p
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                  |
                  | {{ restricao.nome || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
                  |
                  | {{ restricao.cpf_cnpj || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.propriedade') }}:
                  |
                  | {{ restricao.propriedad || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dano') }}:
                  |
                  | {{ restricao.dano || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.aInfrac') }}:
                  |
                  | {{ restricao.a_infrac || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.termoEmbargo') }}:
                  |
                  | {{ restricao.t_embargo || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.datLavrat') }}:
                  |
                  | {{ restricao.dat_lavrat || '-' }}
                  br
                  b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroDoProcesso') }}:
                  |
                  | {{ restricao.n_processo || '-' }}
                  br
                  el-tag.custon-tag(
                      v-if='!existeGeometria(restricoes[index])',
                      size='mini',
                      type='danger'
                  ) Não foi possível recuperar as informações espaciais deste embargo na base disponibilizada pelo órgão.
                  Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                  )
  </template>
    
  <script>
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';
    import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

    export default {
        name: 'lista-area-embargada-sema-mt',
        
        components: {
            Criticidade,
            BaseButton
        },

        data() {
            return {};
        },

        computed: {
            listaRestricoes: function () {
                return this.restricoes.map(value => {
                    if (value.properties) {
                        return {
                            ...value.properties
                        };
                    }
                    return value;
                });
            }
        },
    
        methods: {
            aplicarZoomRestricao(index) {
                let geometriaQueNaoEstavaDentroDasRestricoes = null;
                if (this.geometria) {
                    geometriaQueNaoEstavaDentroDasRestricoes =
                        this.geometria[index];
                }
                this.$emit(
                    'aplicar-zoom-restricao',
                    this.restricoes[index],
                    geometriaQueNaoEstavaDentroDasRestricoes,
                    index
                );
            },
            existeDadosGeoEspaciais(restricao) {
                const { geometry, geometria, properties } = restricao;
    
                if (properties?.latitude && properties?.longitude) {
                    return true;
                }
    
                return (
                    this.habilitarZoomRestricao &&
                    (geometry || geometria || this.geometria)
                );
            },
            existeGeometria(restricao) {
                const { geometry, geometria } = restricao;
    
                if (geometry === undefined && geometria === undefined) {
                    return false;
                }
    
                return true;
            }
        },
    
        props: {
            restricoes: {
                type: Array,
                required: true
            },
            geometria: {
                type: Array,
                required: false,
                default: null
            },
            habilitarZoomRestricao: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    };
  </script>
